import { RACK_MATERIALS_OPTIONS } from '@/shared/constants/configurator';
import { getStaticFileURL } from '@/shared/lib/image';
import clsx from 'clsx';
import styles from './material-option.module.css';
import { MaterialOptionProps } from './material-option.props';

export const MaterialOptions = ({ option, isActive, onChange }: MaterialOptionProps) => {
	const image = RACK_MATERIALS_OPTIONS.find((material) => material.value === option.value)?.image;

	return (
		<div
			onClick={onChange}
			className={clsx(styles.option, {
				[styles.active]: isActive,
			})}
		>
			<p className={styles.label}>{option.label}</p>
			{image && <img className={styles.image} src={getStaticFileURL(image)} />}
		</div>
	);
};
